import * as React from 'react'
import { useTranslation } from 'gatsby-plugin-react-i18next'
import cn from 'classnames'
import UploadLeafletIcon from 'images/icons/ic_upload_leaflet.svg'
import RaiseRateIcon from 'images/icons/ic_raise_rate.svg'
import FillDetail from 'images/icons/ic_fill_detail.svg'
import * as styles from './styles.module.css'

const iconMap = {
  'Upload': UploadLeafletIcon,
  'Raise': RaiseRateIcon,
  'Fill': FillDetail
}

const HowItWorkSection = () => {
  const { t } = useTranslation()
  const stepItem = (type) => (
      <div className={styles.stepRoot}>
        <img className={styles.stepIcon} src={iconMap[type]} alt={t(`landing.howItWork${type}Alt`)} />
        <p className={styles.stepTitle}>{t(`landing.howItWork${type}`)}</p>
      </div>
    )
  return (
    <>
      <div className={cn(styles.sectionRoot, 'container')}>
        <h3>
          {t('landing.howItWork')}
        </h3>
        <span>{t('landing.howItWorkSubTitle')}</span>
        <div className={styles.contentRoot}>
          {stepItem('Upload')}
          {stepItem('Fill')}
          {stepItem('Raise')}
        </div>
      </div>
    </>
  )
}

export default HowItWorkSection